<template>
  <StaticPageLayout
    title="İletişim - INSATEQ"
    description="INSATEQ ekibiyle iletişime geçin. Sorularınız, önerileriniz veya destek talepleriniz için bize ulaşın."
  >
    <!-- Hero -->
    <div class="bg-gradient-to-br from-blue-600 to-indigo-700 py-16">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 class="text-3xl md:text-4xl font-bold text-white mb-4">
          Bizimle İletişime Geçin
        </h1>
        <p class="text-blue-100 text-lg">
          Sorularınız, önerileriniz veya destek talepleriniz için yanınızdayız.
        </p>
      </div>
    </div>

    <!-- Content -->
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid lg:grid-cols-2 gap-12">
        <!-- Contact Form -->
        <div>
          <div class="bg-white rounded-2xl shadow-xl p-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-6">
              Mesaj Gönderin
            </h2>

            <form @submit.prevent="submitForm" class="space-y-6">
              <!-- Name -->
              <div>
                <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
                  Adınız Soyadınız *
                </label>
                <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Adınızı girin"
                />
                <p v-if="errors.name" class="mt-1 text-sm text-red-600">{{ errors.name }}</p>
              </div>

              <!-- Email -->
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                  E-posta Adresiniz *
                </label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="ornek@şirket.com"
                />
                <p v-if="errors.email" class="mt-1 text-sm text-red-600">{{ errors.email }}</p>
              </div>

              <!-- Subject -->
              <div>
                <label for="subject" class="block text-sm font-medium text-gray-700 mb-2">
                  Konu *
                </label>
                <select
                  id="subject"
                  v-model="form.subject"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                >
                  <option value="">Konu seçin</option>
                  <option value="genel">Genel Bilgi</option>
                  <option value="demo">Demo Talebi</option>
                  <option value="fiyat">Fiyatlandırma</option>
                  <option value="teknik">Teknik Destek</option>
                  <option value="oneri">Öneri / Şikayet</option>
                  <option value="diger">Diğer</option>
                </select>
                <p v-if="errors.subject" class="mt-1 text-sm text-red-600">{{ errors.subject }}</p>
              </div>

              <!-- Company (Optional) -->
              <div>
                <label for="company" class="block text-sm font-medium text-gray-700 mb-2">
                  Şirket Adı
                </label>
                <input
                  id="company"
                  v-model="form.company"
                  type="text"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Şirket adınızı girin"
                />
              </div>

              <!-- Message -->
              <div>
                <label for="message" class="block text-sm font-medium text-gray-700 mb-2">
                  Mesajınız *
                </label>
                <textarea
                  id="message"
                  v-model="form.message"
                  required
                  rows="5"
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                  placeholder="Mesajınızı yazın..."
                ></textarea>
                <p v-if="errors.message" class="mt-1 text-sm text-red-600">{{ errors.message }}</p>
              </div>

              <!-- Privacy -->
              <div class="flex items-start">
                <input
                  id="privacy"
                  v-model="form.privacy"
                  type="checkbox"
                  required
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
                />
                <label for="privacy" class="ml-2 text-sm text-gray-600">
                  <a :href="route('privacy')" class="text-blue-600 hover:text-blue-700">Gizlilik Politikası</a>'nı
                  okudum ve kabul ediyorum. *
                </label>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                :disabled="processing"
                class="w-full py-3 px-6 text-white font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span v-if="processing" class="flex items-center justify-center">
                  <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Gönderiliyor...
                </span>
                <span v-else>Mesaj Gönder</span>
              </button>
            </form>

            <!-- Success Message -->
            <div v-if="successMessage" class="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
              <div class="flex items-center">
                <svg class="w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <p class="text-green-800">{{ successMessage }}</p>
              </div>
            </div>

            <!-- Error Message -->
            <div v-if="errorMessage" class="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <div class="flex items-center">
                <svg class="w-5 h-5 text-red-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <p class="text-red-800">{{ errorMessage }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Contact Info -->
        <div class="space-y-8">
          <!-- Direct Contact -->
          <div class="bg-white rounded-2xl shadow-xl p-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-6">
              Doğrudan İletişim
            </h2>

            <div class="space-y-6">
              <!-- Email -->
              <div class="flex items-start">
                <div class="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                  <svg class="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-medium text-gray-900">E-posta</h3>
                  <a href="mailto:destek@insateq.com" class="text-blue-600 hover:text-blue-700 font-medium">
                    destek@insateq.com
                  </a>
                  <p class="text-sm text-gray-500 mt-1">7/24 destek</p>
                </div>
              </div>

              <!-- Address -->
              <div class="flex items-start">
                <div class="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                  <svg class="w-6 h-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-medium text-gray-900">Adres</h3>
                  <p class="text-gray-600">
                    Ceotekmer Teknoloji Merkezi<br />
                    Atakent, Mithatpaşa Cd. No:116<br />
                    34760 Ümraniye / İstanbul
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
            <h2 class="text-xl font-semibold text-gray-900 mb-4">
              Hızlı Erişim
            </h2>
            <div class="space-y-3">
              <a :href="route('pricing')" class="flex items-center text-gray-700 hover:text-blue-600 transition-colors">
                <svg class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Fiyatlandırma
              </a>
              <a :href="route('home') + '#features'" class="flex items-center text-gray-700 hover:text-blue-600 transition-colors">
                <svg class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Özellikler
              </a>
              <a :href="route('register')" class="flex items-center text-gray-700 hover:text-blue-600 transition-colors">
                <svg class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                Ücretsiz Deneyin
              </a>
            </div>
          </div>

          <!-- FAQ Hint -->
          <div class="bg-amber-50 border border-amber-200 rounded-xl p-6">
            <div class="flex items-start">
              <svg class="w-6 h-6 text-amber-500 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
              </svg>
              <div>
                <h3 class="font-medium text-amber-800">Sık Sorulan Sorular</h3>
                <p class="text-sm text-amber-700 mt-1">
                  Sıkça sorulan soruların cevapları için
                  <a :href="route('home') + '#faq'" class="underline hover:text-amber-900">SSS bölümümüzü</a>
                  ziyaret edebilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </StaticPageLayout>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { router } from '@inertiajs/vue3'
import StaticPageLayout from '@/Layouts/StaticPageLayout.vue'

const form = reactive({
  name: '',
  email: '',
  subject: '',
  company: '',
  message: '',
  privacy: false
})

const errors = ref({})
const processing = ref(false)
const successMessage = ref('')
const errorMessage = ref('')

const submitForm = () => {
  processing.value = true
  successMessage.value = ''
  errorMessage.value = ''
  errors.value = {}

  router.post(route('contact.submit'), form, {
    preserveScroll: true,
    onSuccess: () => {
      successMessage.value = 'Mesajınız başarıyla gönderildi. En kısa sürede size döneceğiz.'
      // Reset form
      form.name = ''
      form.email = ''
      form.subject = ''
      form.company = ''
      form.message = ''
      form.privacy = false
    },
    onError: (errs) => {
      errors.value = errs
      errorMessage.value = 'Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.'
    },
    onFinish: () => {
      processing.value = false
    }
  })
}
</script>
